import React from "react"

import client from "./src/lib/apollo-client"
import { ApolloClient, ApolloProvider, InMemoryCache } from "@apollo/client"
import { CartOpenContextProvider } from "./src/components/context/cartOpenContext"
import { ReferrerContextProvider } from "./src/components/context/referrerContext"

export const wrapRootElement = ({ element }) => {
  return (
    <ApolloProvider client={client}>
      <ReferrerContextProvider>
        <CartOpenContextProvider>{element}</CartOpenContextProvider>
      </ReferrerContextProvider>
    </ApolloProvider>
  )
}

// const Wrapper = ({ element }) => {
//   return <WrapRootElement element={element} />
// }

// exports.wrapRootElement = Wrapper
